import type { JSX, ReactNode } from 'react'
import { cn } from '@ttab/elephant-ui/utils'

export const StreamEntryCell = ({ children, className, wrap = false }: {
  children: ReactNode
  className?: string
  /**
   * Let the text run onto more lines rather than be cut off. Clamped rather
   * than unbounded, so one long headline cannot crowd out the rows under it.
   */
  wrap?: boolean
}): JSX.Element => {
  return (
    <div
      className={cn(
        'px-2 py-2',
        'first:ps-4 first:font-thin first:opacity-65',
        'last:pe-4 last:min-w-0 last:tracking-[0.015em]',
        !wrap && 'last:truncate',
        className
      )}
    >
      {/*
        The clamp sits on a child rather than on the cell. line-clamp works by
        setting display to -webkit-box, and the cell is a grid item, whose
        display the grid overrides - so on the cell itself the text keeps
        wrapping and spills past the row instead of being cut at three lines.
      */}
      {wrap ? <span className='line-clamp-3'>{children}</span> : children}
    </div>
  )
}
